const imageCarousel = document.querySelectorAll(".js-image-carousel");
const fixedImageCarousel = document.querySelectorAll(".js-fixed-image-carousel");
const aboutImageCarousel = document.querySelectorAll(".js-about-image-carousel");

if (typeof imageCarousel != "undefined" && imageCarousel != null) {

    imageCarousel.forEach((carousel) => {
        const flkty = new Flickity(carousel, {
            cellAlign: "left",
            contain: true,
            draggable: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            cellSelector: ".image-carousel__slide"
        });

        const nextButton = carousel.querySelector(".js-image-carousel-next");

        nextButton.addEventListener("click", (e) => {
            e.preventDefault();
            flkty.next();
        });

        const prevButton = carousel.querySelector(".js-image-carousel-prev");

        prevButton.addEventListener("click", (e) => {
            e.preventDefault();
            flkty.previous();
        });

        flkty.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
            if ( !cellElement ) {
                return;
            }
            flkty.selectCell( cellIndex )
        });

        document.addEventListener('lazyLoad', function () {
           // console.log('img loaded');
            setTimeout(function(){ flkty.resize(); }, 400);
            
        }, false);

        document.addEventListener('lazyLoadComplete', function () {
            //console.log('all ims loaded');
            setTimeout(function(){ flkty.resize(); }, 400);
        }, false);

    });
}

if (typeof fixedImageCarousel != "undefined" && fixedImageCarousel != null) {

    fixedImageCarousel.forEach((fixedCarousel) => {
        const flkty = new Flickity(fixedCarousel, {
            cellAlign: "center",
            fade: true,
            autoPlay: 3000,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: false,
            imagesLoaded: true,
            setGallerySize: false,
            resize: true
        });
    });

}


if (typeof aboutImageCarousel != "undefined" && aboutImageCarousel != null) {

    aboutImageCarousel.forEach((imgcarousel) => {
        const flkty = new Flickity(imgcarousel, {
            cellAlign: "center",
            fade: true,
            autoPlay: 3000,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: false,
            imagesLoaded: true,
            setGallerySize: false,
            resize: true
        });
    });

}
